import React, { useState } from 'react';
import { AlertOctagonIcon, ChevronDownIcon, LockIcon, MailCheckIcon, WifiOffIcon } from 'lucide-react';
import type { IntegrationError } from '../types/disclosures';
const iconFor = {
  loan_locked: LockIcon,
  already_sent: MailCheckIcon,
  no_package: AlertOctagonIcon,
  connection: WifiOffIcon
};
interface IntegrationErrorCardProps {
  error: IntegrationError;
  onAction: () => void;
}
export function IntegrationErrorCard({
  error,
  onAction
}: IntegrationErrorCardProps) {
  const [showDetails, setShowDetails] = useState(false);
  const Icon = iconFor[error.kind];
  const blocking = error.kind === 'connection';
  return <section className={`rounded-xl border bg-white ${blocking ? 'border-red-200' : 'border-amber-200'}`} data-id="element-139" data-mp="1yuixi3ysaybw">
      <div className={`flex flex-col gap-4 px-5 py-4 sm:flex-row sm:items-center sm:justify-between ${blocking ? 'bg-red-50/60' : 'bg-amber-50/60'} rounded-t-xl`} data-id="element-140" data-mp="1tylic0z9by0p">
        <div className="flex items-start gap-3" data-id="element-141" data-mp="22v2th47mfvwg">
          <span className={`mt-0.5 flex h-9 w-9 shrink-0 items-center justify-center rounded-full ${blocking ? 'bg-red-100 text-red-600' : 'bg-amber-100 text-amber-700'}`} data-id="element-142" data-mp="3tyfrlk0d1q94">
            <Icon className="h-4 w-4" aria-hidden="true" data-id="element-143" data-mp="7ov15vodysvt" />
          </span>
          <div data-id="element-144" data-mp="cqaknjax0rc3">
            <p className="text-[14px] font-semibold text-slate-900" data-id="element-145" data-mp="cqu4j5k4lpsr">{error.title}</p>
            <p className="mt-0.5 max-w-xl text-[13px] leading-5 text-slate-600" data-id="element-146" data-mp="gq2z2cmzprpd">{error.message}</p>
          </div>
        </div>
        <button type="button" onClick={onAction} className="shrink-0 rounded-md bg-slate-900 px-3.5 py-2 text-[13px] font-semibold text-white transition hover:bg-slate-800 focus:outline-none focus-visible:ring-2 focus-visible:ring-slate-900 focus-visible:ring-offset-2" data-id="element-147" data-mp="lo4e8mhap6vk">
          {error.actionLabel}
        </button>
      </div>

      <div className="border-t border-slate-100 px-5 py-2.5" data-id="element-148" data-mp="14hgooatrb96n">
        <button type="button" onClick={() => setShowDetails(value => !value)} aria-expanded={showDetails} className="inline-flex items-center gap-1 text-[12px] font-medium text-slate-400 transition hover:text-slate-600 focus:outline-none focus-visible:ring-2 focus-visible:ring-blue-500" data-id="element-149" data-mp="31gtdpaco4rck">
          Technical Details
          <ChevronDownIcon className={`h-3.5 w-3.5 transition-transform ${showDetails ? 'rotate-180' : ''}`} data-id="element-150" data-mp="35gjzeznc8ha8" />
        </button>
        {showDetails && <pre className="mt-2 overflow-x-auto rounded-md bg-slate-900 px-3 py-2.5 text-[11px] leading-5 text-slate-200" data-id="element-151" data-mp="3f7y6bshmcjde">
            {error.technicalDetails}
          </pre>}
      </div>
    </section>;
}